import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { API_BASE_URL } from './config.js'


// 检查是否已引入Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'


// 设置axios默认超时时间（毫秒）
axios.defaults.timeout = 60000; // 设置为60秒


// 设置 axios 请求拦截器，自动添加 token
axios.interceptors.request.use(config => {
    
  // 确保URL使用HTTPS
  if (config.url && config.url.startsWith('http:')) {
    config.url = config.url.replace('http:', 'https:')
  }
    
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 确保baseURL使用HTTPS
axios.defaults.baseURL = API_BASE_URL.replace(/^http:/, 'https:').replace(/\/api$/, '')

const app = createApp(App)

// 设置默认的请求头
if (store.state.token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`
}

app.use(router)
app.use(store)
app.mount('#app')


// 在应用中注册Element Plus
app.use(ElementPlus, {
  locale: zhCn
})
